import { render } from "./i18n-number.vue?vue&type=template&id=220dcd7e&ts=true"
import script from "./i18n-number.vue?vue&type=script&lang=ts"
export * from "./i18n-number.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__